/* eslint-disable @typescript-eslint/no-unused-vars */

import Swiper from 'swiper/bundle';

/* Latest productions */
new Swiper('.latest-production-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 15,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

/* Agenda productions */
const agendaSwiperEl = document.querySelector('.agenda-swiper');

if (agendaSwiperEl) {
  const monthSpan = agendaSwiperEl.querySelector('.agenda-month .month-name');

  const swiper = new Swiper(agendaSwiperEl, {
    navigation: {
      nextEl: '.next-agenda',
      prevEl: '.prev-agenda',
    },
    on: {
      init: function () {
        updateMonth(this);
      },
      slideChange: function () {
        updateMonth(this);
      },
    },
  });

  function updateMonth(swiper) {
    const currentSlide = swiper.slides[swiper.activeIndex];
    if (!currentSlide || !monthSpan) return;
    monthSpan.textContent = currentSlide.getAttribute('data-month');
  }
}

/* Selection productions */
new Swiper('.selection-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

/* List productions */
new Swiper('.list-production-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 0,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

/* Other post */
new Swiper('.other-post-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 15,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

/* eslint-enable @typescript-eslint/no-unused-vars */
